import { HexIconAnimation } from './_types';

export const animationByType: Record<HexIconAnimation, string | undefined> = {
  blink: '2s infinite normal blink',
  pulsate: '1s infinite alternate pulsate',
  pulsateSlow: '1.3s infinite alternate pulsateSlow',
  none: undefined,
};
